namespace $ {

	$mol_style_define( $bog_ui_app_empty, {

		padding: $mol_gap.block,
		gap: '1.5rem',

		Description: {
			color: $mol_theme.shade,
		},

		Section_default: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
		},

		Section_custom: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
		},

		Section_action: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
		},

	} )

}
